angular.module("app").constant("pageStatuses", [
    "published",
    "inactive",
    "archive"
]);

angular.module("app").constant("backgroundAttachment", [
    "scroll",
    "fixed"
]);
angular.module("app").constant("repeatCSS", [
    {key: "", value: ""},
    {key: "Repeat", value: "repeat"},
    {key: "Repeat Horizontally", value: "repeat-x"},
    {key: "Repeat Vertically", value: "repeat-y"},
    {key: "No Repeat", value: "no-repeat"}
]);

angular.module("app").constant("backgroundSize", [{
        key: "",
        value: ""
    }, {
        key: "cover",
        value: "cover"
    }, {
        key: "contain",
        value: "100%'"
    }, {
        key: "orginal",
        value: "auto"
    }, {
        key: "custom",
        value: "custom"
    }
]);

angular.module("app").constant("booleanType", [
    "true",
    ""
]);

angular.module("app").constant("liveDealerClasses", [
    "",
    "roulette-b",
    "blackjack-b",
    "baccarat-b",
    "live-bet-on-poker",
    "betonpoker-b",
    "betonbaccarat-b",
    "russianpoker-b"
]);

angular.module("app").constant("liveCasinoPageDefaults", {
    columnQuantity: 4,
    gridContainerType: "guide",
    backgroundSize: {
        contain: '100%',
        cover: 'cover',
        original: 'auto'
    },
    defaultBackgroundSizeType: "contain",
    align: "flex-start",
    gridGaps: 44,
    color: 'transparent'
});
angular.module("app").constant("skillGamesPageDefaults", {
    backgroundSize: {
        contain: '100%',
        cover: 'cover',
        original: 'auto'
    },
    defaultBackgroundSizeType: "contain",
    color: 'transparent'
});
angular.module("app").constant("backgroundPageDefaults", {
    backgroundSize: {
        contain: '100%',
        cover: 'cover',
        original: 'auto'
    },
    defaultBackgroundSizeType: "contain",
    color: 'transparent'
});

angular.module("app").constant("pageTypes", [
    "news",
    "sidebar",
    "text",
    "category",
    "promo",
    "background"
]);

angular.module("app").constant("aligns", [
    "l1",
    "l2",
    "r1",
    "r2"
]);


angular.module("app").constant("jackpotTypes", ['nothing', 'all', 'global', 'betconstruct']);

angular.module("app").constant("targets", [
    "_blank",
    "_self"
]);

angular.module("app").constant("casinoGameTypes", [
    'is_real_play',
    'is_download',
    'is_target',
    'is_for_fun',
    'is_view_mode'
]);
angular.module("app").constant("casinoSkinGameTypes", [
    'is_real_play',
    'is_for_fun',
    'is_view_mode'
]);

angular.module("app").constant("ratios", [
    {'title': '3:4', 'value': '3:4'},
    {'title': '4:3', 'value': '4:3'},
    {'title': '16:9', 'value': '16:9'},
    {'title': 'Full', 'value': "0"},
    {'title': 'custom', 'value': 'custom'}

]);

angular.module("app").constant("dateRangeConstants", [
    {
        name: "1 hour",
        value: 3600
    },
    {
        name: "3 hours",
        value: 10800
    },
    {
        name: "5 hours",
        value: 18000
    },
    {
        name: "1 day",
        value: 86400
    },
    {
        name: "3 days",
        value: 259200
    },
    {
        name: "5 days",
        value: 432000
    },
    {
        name: "1 week",
        value: 604800
    }
]);


angular.module("app").constant("markets", [
    {
        key: "4",
        value: "Europe Studio"
    },
    {
        key: "50",
        value: "Eastern Europe Studio"
    },
    {
        key: "60",
        value: "Baltic Studio"
    },
    {
        key: "30",
        value: "Asian Studio"
    },
    {
        key: "1",
        value: "Latin America Studio"
    }
]);

angular.module("app").constant("popupTypes", [
    "0",
    "1",
    "2"
]);

/*angular.module("app").constant("cGameBadges", [
    {
        value: "0",
        text: "No badge"
    },
    {
        value: "1",
        text: "New"
    },
    {
        value: "2",
        text: "Jackpot"
    }
]);*/

angular.module("app").constant("showSetForAllLang", {
    "under-betslip-banners-russia": true,
    "under-betslip-banners-classic": true
} );
angular.module("app").constant("isChangeVersionPageSlug", {
    "general-terms-and-conditions": true,
    "privacy-policy": true,
    "sportsbook-rules": true
} );

angular.module("app").constant("bannerShowFor", {
        values: [
            {key: "Guests", value: "2"},
            {key: "Logged in", value: "1"},
            {key: "Both", value: "0"}
        ],
        defaultValue: "0"
});
angular.module("app").constant("pagesContentRequired", {
    "news": true,
    "promo": true
});

angular.module("app").constant("newWindow", [
    {
        key: "Yes",
        value: "1"
    },
    {
        key: "No",
        value: "0"
    },
    {
        key: "Iframe",
        value: "2"
    }
]);
angular.module("app").constant("androidAppPromoLogoURL", [
    {
        key: "",
        value: ""
    },
    {
        key: "Casino",
        value: "/content/android/logos/casino.svg"
    },
    {
        key: "Belote",
        value: "/content/android/logos/belote.svg"
    },
    {
        key: "Fantasy Sport",
        value: "/content/android/logos/fantasy-sport.svg"
    }
]);
angular.module("app").constant("promoDevice", [
    {
        key: "For Both",
        value: 0
    },
    {
        key: "Web",
        value: 1
    },
    {
        key: "Mobile",
        value: 2
    }
]);

angular.module("app").constant('casinoLabels',[
    {text: "None", value: ""},
    {text: "New", value: "new"},
    {text: "Promo", value: "promo"},
    {text: "Jackpot", value: "jackpot"},
    {text: "Top", value: "top"},
    {text: "Exclusive", value: "exclusive"},
    {text: "VPN", value: "vpn"},
    {text:"Tournament", value: "tournament"},
    {text:"Hot", value: "hot"},
    {text:"Ortak", value: "ortak"},
    {text:"Trending ", value: "trending"},
]);
